<template>
<div class="home">
  <div class="home--page">
    资产运营检查
  </div>
  <div class="home-page-line"></div>
  <div class="home--market--mgr">
    <div class="market--mgr__item">
      <div class="mgr--docker__item" @click="handleToForwardRouter('addcheck')">
        <div class="iconfont title">&#xe98c;</div>
        新增检查
      </div>
      <div class="mgr--docker__item" @click="handleToForwardRouter('verifylist')">
        <div class="iconfont title">&#xe993;</div>
        待审批检查
      </div>
      <div class="mgr--docker__item" @click="handleToForwardRouter('hisassets')">
        <div class="iconfont title">&#xe98d;</div>
        检查记录
      </div>
      <div class="mgr--docker__item" @click="handleToForwardRouter('addassets')" v-if="false">
        <div class="iconfont title">&#xe99d;</div>
        新增资产
      </div>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">

export default {
  name: 'AssetsHome',
  methods: {
    handleToForwardRouter (routerName) {
      this.$router.push({ name: routerName })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.home
  position : relative
  width : 100vw
  overflow : hidden
  background-color : #ffffff
  .home--page
    position : fixed
    top:0
    left :0
    width : 100%
    height : 85px
    line-height : 85px
    text-align : center
    background : #687591
    font-family: MyriadPro-Regular
    font-size: 38px
    font-weight: normal
    font-stretch: normal
    color: #ffffff
  .home-page-line
    width : 100%
    height : 85px
  .home--market--mgr
    .market--mgr__title
      margin : 0
      padding : 16px
      background-color : #ffffff
      font-family: MyriadPro-Regular
      font-size: 32px
      font-weight: 600
      font-stretch: normal
      letter-spacing: 0px
      color: #333333
    .market--mgr__item
      padding-bottom : 16px
      display : flex
      flex-wrap : wrap
      .mgr--docker__item
        width : 25%
        margin-top : 24px
        text-align : center
        font-size : 32px
        font-weight: normal
        font-stretch: normal
        letter-spacing: 0px
        color: #333333
        .title
          padding-bottom : 8px
          color : #4282e1
          font-size : 48px
      .mgr--docker__box
        position : relative
        .box--item
          position : absolute
          top:-15px
          right :40px
          width : 20px
          line-height : 20px
          padding : 4px
          text-align : center
          border : 1px solid #db4848
          border-radius : 50%
          font-size : 20px
          color : #db4848
</style>
